import React from 'react';
import { RSButton } from 'reactsymbols-kit';
import Styles from '../../styles/colors';
import type { IInheritance } from '../../stores/model/metamodel/inheritance';
import type { IModelVersion } from '../../merode/controllers/Controller';
import type Report from '../../merode/checks/Report';

interface InheritanceInspectorProps {
  /** The inheritance to inspect. */
  inheritance: IInheritance;
  /** Callback to call when the inheritance should be deleted. */
  onDelete?: (id: string) => void;
  /**
   * The ModelVersion. Passed by the Inspector container for parity with the
   * other inspectors but unused here (the component renders read-only info).
   */
  version?: IModelVersion;
  /**
   * Callback to call when a report is generated. Passed by the container for
   * parity but unused here.
   */
  onReport?: (report: Report) => void;
  /** Callback to close the inspector. Passed for parity but unused here. */
  requestClose?: () => void;
}

const InheritanceInspector = ({ inheritance, onDelete }: InheritanceInspectorProps) => {
  return (
    <div className="inheritance-inspector flex h-full flex-col">
      <div className="inheritance-content flex-1 overflow-auto px-[15px] py-5">
        <dl className="mt-0">
          <dt className="block font-semibold">Supertype: </dt>
          <dd className="mb-[15px] block ps-0 pl-[15px]">{inheritance.supertype.name}</dd>
          <dt className="block font-semibold">Subtype: </dt>
          <dd className="mb-[15px] block ps-0 pl-[15px]">{inheritance.subtype.name}</dd>
          <dt className="block font-semibold">Abstract supertype?</dt>
          <dd className="mb-0 block ps-0 pl-[15px]">{inheritance.supertype.abstract ? 'yes' : 'no'}</dd>
        </dl>
      </div>
      <div className="remove-inheritance p-[15px]">
        <RSButton
          background={Styles.redGradient}
          value="Delete inheritance"
          onClick={() => {
            if (onDelete) onDelete(inheritance.id);
          }}
        />
      </div>
    </div>
  );
};

export default InheritanceInspector;
